import SEOLandingTemplate from './SEOLandingTemplate';

export default function GrammarCheckerPage() {
  return (
    <SEOLandingTemplate
      title="Grammar Checker"
      metaTitle="Free Grammar Checker | Sungresh"
      metaDescription="Check grammar, spelling, and punctuation with AI, and get a writing score with specific suggestions."
      h1="Free Grammar Checker"
      sub="Paste your text to get grammar, spelling, and punctuation feedback, along with a writing score and specific suggestions for clarity and style."
      keywords="grammar checker, free grammar checker, spell checker, grammar check"
      ctaLink="/content"
      ctaText="Check Grammar Free"
      features={[
        { icon: '✅', title: 'Grammar Check', desc: 'Flags common grammar issues' },
        { icon: '🔤', title: 'Spell Checker', desc: 'Highlights spelling errors' },
        { icon: '✍️', title: 'Punctuation', desc: 'Comma, apostrophe, and quotation issues' },
        { icon: '💡', title: 'Style Suggestions', desc: 'Clarity and conciseness feedback' },
      ]}
      faqs={[
        { q: 'How accurate is AI-based grammar checking?', a: 'It\'s generally reliable for common errors like subject-verb agreement, tense consistency, and punctuation, but no automated checker catches everything — especially in longer, more nuanced writing. Treat suggestions as a helpful pass, not a final word.' },
        { q: 'Does it check for plagiarism too?', a: 'No — this tool focuses on grammar, spelling, and style. For checking whether content is AI-generated, use our separate AI Checker tool.' },
        { q: 'Is short text less reliable to check?', a: 'Yes, very short snippets give the checker less context to work with, so results tend to be more reliable on full sentences and paragraphs than single fragments.' },
      ]}
    />
  );
}
